import React, { createContext, useContext, useState } from 'react';
import { useSearch } from '../InputSearchContext';
const CalendarContext = createContext(undefined);
export const CalendarProvider = ({ children }) => {
    const { handleClose } = useSearch();
    const [selectedDepartureDate, setSelectedDepartureDate] = useState(null);
    const [selectedReturnDate, setSelectedReturnDate] = useState(null);
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const [isDateModalVisible, setIsDateModalVisible] = useState(false);
    const [activeButton, setActiveButton] = useState('departure');
    const openCalendar = () => setIsCalendarOpen(true);
    const closeCalendar = () => setIsCalendarOpen(false);
    const showDateModal = () => setIsDateModalVisible(true);
    const closeDateModal = () => setIsDateModalVisible(false);
    const selectDate = (date) => {
        if (!selectedDepartureDate || (selectedDepartureDate && selectedReturnDate)) {
            setSelectedDepartureDate(date);
            setSelectedReturnDate(null);
            setActiveButton('return');
        }
        else if (selectedDepartureDate && !selectedReturnDate) {
            setSelectedReturnDate(date);
            handleClose();
            closeDateModal();
            setActiveButton('departure');
        }
    };
    const onDateSelect = (date) => {
        selectDate(date);
    };
    return (React.createElement(CalendarContext.Provider, { value: {
            selectedDepartureDate,
            selectedReturnDate,
            isCalendarOpen,
            isDateModalVisible,
            activeButton,
            openCalendar,
            closeCalendar,
            showDateModal,
            closeDateModal,
            selectDate,
            onDateSelect,
            setActiveButton,
        } }, children));
};
export const useCalendar = () => {
    const context = useContext(CalendarContext);
    if (context === undefined) {
        throw new Error('useCalendar must be used within a CalendarProvider');
    }
    return context;
};
//# sourceMappingURL=index.js.map